import { buildVenuePath } from '../utils/venueRouting';
// src/pages/DiscoverSub.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import BackButton from '../components/BackButton';
import AdvTabs from '../components/AdvTabs';
import SearchTabs from '../components/SearchTabs';
import { contentLog } from '../utils/Accesslog.js';
import { resolveSidebarIconSrc } from '../utils/IconSource.js';

const DiscoverSub = () => {
  const { id } = useParams();
  const { contentInfo, hotelInfo, venueId, theme } = useContext(AppContext);
  const [detail, setDetail] = useState(null); //存储内容
  const [history, setHistory] = useState([]); // 历史路由
  const navigate = useNavigate();
  useEffect(() => {
    const findNodeById = (tid, node, hist) => {
      const queue = [[node, hist]];
      while (queue.length > 0) {
        const [currentNode, currentHist] = queue.shift();
        if (currentNode.id === tid) return [currentNode, currentHist];
        if (currentNode.attributes) {
          queue.push(...currentNode.attributes.map((data) => [data, [...currentHist, currentNode.name]]));
        }
      }
      return [null, []];
    };

    if (id && contentInfo) {
      const [node, hist] = findNodeById(id, contentInfo, []);
      setDetail(node);
      hist.shift();
      setHistory(hist);
    }
  }, [contentInfo, id]);

  const handleServiceClick = (data) => {
    contentLog(venueId, data.id);
    if (data.isLeaf) {
      navigate(buildVenuePath(`/discover/detail/${data.id}`, venueId));

    }
    else
      navigate(buildVenuePath(`/discover/list/${data.id}`, venueId))
  }

  if (!hotelInfo) { return <div>Loading...</div>; }

  const discoverHeader = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.discoverHeader || 'rgb(0,0,0)');
  const discoverCardsTitle = (theme?.color || theme?.secondaryColor) ? 'rgb(0,0,0)' : (theme?.discoverCardsTitle || 'rgb(0,0,0)');
  const discoverEntriesBackground = (theme?.color || theme?.secondaryColor) ? 'rgb(243,244,246)' : (theme?.discoverEntriesBackground || 'rgb(243,244,246)');
  const discoverCardsBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.discoverCardsBackground || 'rgb(255,255,255)';

  return (
    <div className='min-h-[calc(100vh-9rem)] bg-gray-100'>
      <SearchTabs />
      <BackButton />
      {history && history.length > 0 && <div className='py-2 px-4 bg-white'>
        {history && history.length > 0 && history.map((name) => (
          <span key={name} className='text-sm'>&nbsp;{name}&nbsp;&gt;</span>))}
        {detail && <span className='font-semibold text-sm'>&nbsp;{detail.name}</span>}
      </div>}
      <div className='px-4 py-2' style={{ backgroundColor: discoverEntriesBackground }}>
        {detail && <p className='font-semibold text-lg pb-4 pt-2' style={{ color: discoverHeader }}>{detail.name}</p>}
        <div className='grid grid-cols-2 max-w-md mx-auto px-2'>
          {detail && detail.attributes && detail.attributes.length > 0 && detail.layoutStyle === "sidebar" &&
            detail.attributes.map((data, index) => {
              const iconSrc = resolveSidebarIconSrc(data);
              return (
                <div key={data.id} className="flex flex-col items-center px-2 py-2 m-2  rounded-lg min-h-28" 
                style={{ backgroundColor: discoverCardsBackground }}
                  onClick={() => handleServiceClick(data)}>

                  <div className="w-full flex items-center justify-center m-2">
                    {iconSrc && (
                      <img
                        src={iconSrc}
                        alt={"IconImage " + index}
                        className="object-cover rounded-lg w-12 h-12"
                        onError={(event) => {
                          event.currentTarget.style.display = 'none';
                        }}
                      />
                    )}
                  </div>
                  <p className="font-semibold text-center mt-0 text-sm" style={{ color: discoverCardsTitle }}>{data.name}</p>
                </div>
              );
            })}

          {detail && detail.attributes && detail.attributes.length > 0 && detail.layoutStyle === "overlay" &&
            detail.attributes.map((data, index) => (
              <div key={data.id} className="flex flex-col items-center px-2 pt-2 "
                onClick={() => handleServiceClick(data)}>
                <div className="w-full aspect-w-1 aspect-h-1">
                  <img
                    src={data.bannerImage}
                    alt={"BannerImage " + index}
                    className="object-cover rounded-lg w-full h-full bg-white"
                    style={{ boxShadow: '0 0.3rem 0.3rem rgba(0, 0, 0, 0.1)' }}
                  />
                </div>
                <p className="mt-1 font-semibold text-center text-sm" style={{ color: discoverCardsTitle }}>{data.name}</p>
              </div>
            ))}
        </div>
      </div>
      <AdvTabs origin={'Discover'} />
    </div>
  );
};

export default DiscoverSub;
